var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "copy-2-clip-wrapper",
      on: {
        click: [
          _vm.doCopy,
          function ($event) {
            $event.stopPropagation()
          },
        ],
      },
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { top: "", "position-y": 5 },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "span",
                      _vm._g(
                        _vm._b(
                          { staticClass: "copy-2-click-text" },
                          "span",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._t("default")],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "copy-button",
                            attrs: { icon: "", height: "24px", width: "24px" },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c("v-icon", { attrs: { size: 14 } }, [
                          _vm._v("mdi-content-copy"),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ],
            null,
            true
          ),
          model: {
            value: _vm.showCopied,
            callback: function ($$v) {
              _vm.showCopied = $$v
            },
            expression: "showCopied",
          },
        },
        [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltip))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }